import React, { useEffect } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  FlatList,
} from "react-native";
//import FastImage from 'react-native-fast-image';
import { connect } from "react-redux";
import { Color, globalFontStyle, globalStyle } from "../../assets";
import { cross_subcat, cross_white_black } from "../../utils/images";
import ClubsCard from "./childComponents/clubsCard";
import { getClubList } from "./redux/clubs.action";
import { trackMoengageEvent } from "../../utils/commonMethods";
import {globalConfigurableData, globalConst} from "../../utils/globalConstant";

const Clubs = ({ getClubList, clubList, loading, navigation }) => {
  useEffect(() => {
    fetchClubList();
  }, []);

  const fetchClubList = async () => {
    await getClubList();
  };
  const onOptionClick = (club, club_id) => {
    trackMoengageEvent("Club card click", {
      Club_id: club_id,
      clubName: club?.title,
      members: club?.total_members,
      activeMarkets: club?.active_markets,
    });
    navigation.push("ClubMarkets", { club_id: club.item.id });
  };
  const onBackClick = () => {
    navigation.pop();
  };

  return (
    <View style={{ backgroundColor: Color.bgWhite, flex: 1 }}>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          paddingVertical: 15,
          alignItems: "center",
          borderBottomColor: "rgba(0, 0, 0, 0.5)",
          paddingHorizontal: 16,
          borderBottomWidth: 0.274757,
        }}
      >
        <View style={{ flexDirection: "row" }}>
          <Text style={globalFontStyle.appFontTitleHead}>{globalConfigurableData?.appName}</Text>
          <View style={styles.clubsTxtStyle}>
            <Text
              style={[globalFontStyle.appFontSubText, { color: Color.bgWhite }]}
            >
              Clubs
            </Text>
          </View>
        </View>

        <TouchableOpacity onPress={onBackClick}>
          {/* <FastImage
            resizeMode={FastImage.resizeMode.contain}
            style={styles.crossImg}
            source={cross_white_black()}
          /> */}
        </TouchableOpacity>
      </View>
      <View style={{ paddingHorizontal: 16 }}>
        <FlatList
          contentContainerStyle={{ paddingBottom: 350 }}
          //ListHeaderComponent={headerComponent}
          scrollEnabled
          data={clubList}
          renderItem={(itemList, index) => {
            return (
              <TouchableOpacity
                activeOpacity={0.8}
                onPress={() => {
                  onOptionClick(itemList, itemList?.id);
                }}
              >
                <ClubsCard clubDetails={itemList.item} />
              </TouchableOpacity>
            );
          }}
          //onRefresh={PullToRefresh}
          //refreshing={loading}
          //keyExtractor={(item, index) => index}
          showsVerticalScrollIndicator={false}
          initialNumToRender={50}
        />
      </View>
    </View>
  );
};

const mapStateToProps = ({ socialClubReducer }) => ({
  clubList: socialClubReducer?.clubList,
  loading: socialClubReducer.clubLoading,
});
const mapDispatchToProps = {
  getClubList,
};

export default connect(mapStateToProps, mapDispatchToProps)(Clubs);

const styles = StyleSheet.create({
  crossImg: {
    width: 20,
    height: 20,
  },
  clubsTxtStyle: {
    paddingHorizontal: 20,
    paddingVertical: 12,
    backgroundColor: Color.blue1,
    borderRadius: 25,
    marginLeft: 7,
  },
});
